import $ from "jquery";

$('.language_switcher').on('click', function() {
  if($(this).hasClass('open')) {
    $(this).removeClass('open');
  } else {
    $(this).addClass('open');
  }
});

